import React from 'react';
import {
  ParagraphSmall,
  ParagraphSmall500,
} from 'lib/components/styles/typography';
import { Dropdown } from 'lib/components';
import styled, { useTheme } from 'styled-components/macro';
import { Flex } from 'lib/components/styles/layout';
import { Option } from './types';
import { useTranslation } from 'react-i18next';
import { getSecondaryColor } from 'lib/context/theme/utils';

type Props = {
  shareWithOption: Option;
  shareWithDropdownOptions: Option[];
  selectedEntities: Option[];
  handleSelectShareWithOption: (value: Option, array: Option[]) => void;
};

const HelpText = styled(ParagraphSmall)`
  color: ${({ theme }) => getSecondaryColor(theme, 40)};
  margin-top: 8px;
`;

export const ShareWithDropdown = ({
  shareWithOption,
  handleSelectShareWithOption,
  shareWithDropdownOptions,
  selectedEntities,
}: Props) => {
  const themes = useTheme();
  const { t } = useTranslation();

  return (
    <Flex gap='10px'>
      <ParagraphSmall500 color={themes.colors.neutral[80]}>
        {t('Share with*')}
      </ParagraphSmall500>
      <Dropdown
        extendStyles={{
          option: {
            padding: '0px',
          },
          menuList: {
            padding: '20px',
            gap: '10px',
            display: 'flex',
            flexDirection: 'column',
            border: '1px',
          },
        }}
        width={798}
        placeholder={''}
        value={shareWithOption}
        onChange={newValue => {
          handleSelectShareWithOption(newValue, []);
        }}
        options={shareWithDropdownOptions}
        height={40}
        creatable={false}
        disabled={!!selectedEntities?.length}
        formatOptionLabel={(
          data: any,
          formatOptionMeta: { context: 'menu' | 'value' }
        ) => {
          const { context } = formatOptionMeta;
          if (context === 'menu') {
            return (
              <Flex gap='8px' padding='12px 8px 12px 8px' flexDirection='row'>
                <ParagraphSmall500 width='160px'>
                  {data.label}
                </ParagraphSmall500>
              </Flex>
            );
          }
          return data.label;
        }}
      />
      {shareWithOption?.value === 'reseller' && (
        <HelpText>
          {t(
            'By Selecting All Company Users grants access to everyone within your organization—now and moving forward.'
          )}
        </HelpText>
      )}
    </Flex>
  );
};
